<template>
  <div>
    <div
      id="login_container"
      :style="{ background: 'url(' + $store.state.csr.loginBgPic + ') center' }"
    >
      <div id="nav">
        <div class="content clearfloat">
          <img :src="$store.state.csr.linkLogoPic" />
          <h1>{{ $store.state.csr.name }}</h1>
        </div>
      </div>
      <div class="content clearfloat">
        <!-- <div id="bvad">
          <h2>关注客户 社会所驱</h2>
          <p>Focus on customers driven by society</p>
        </div> -->
        <div id="login-box">
          <h2>欢迎登录系统</h2>

          <Form ref="caritem" :model="loginMsg" :label-width="80">
            <Row :gutter="16">
              <Col span="24">
                <FormItem label="用户名" prop="username">
                  <Input v-model="loginMsg.username" placeholder="请输入"
                    ><template #append>
                      <Button @click="$refs.moreAcount.reach()"
                        >切换用户</Button
                      >
                    </template></Input
                  >
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="密码" prop="password">
                  <Input
                    v-model="loginMsg.password"
                    placeholder="输入6位以上密码"
                    type="password"
                    password
                  ></Input>
                </FormItem>
              </Col>
            </Row>
          </Form>
          <Button
            :disabled="
              loginMsg.username.length == 0 || loginMsg.password.length < 6
            "
            id="loginBtn"
            long
            :loading="loading"
            @click="login"
          >
            <span v-if="!loading">立即登录</span>
            <span v-else>登录中...</span>
          </Button>
          <Checkbox
            v-model="storagePasspord"
            id="loginCheck"
            :disabled="
              loginMsg.username.length == 0 || loginMsg.password.length < 6
            "
            >记住用户名和密码</Checkbox
          >
        </div>
        <ul
          id="erweima"
          v-if="
            $store.state.csr.qrCodeList &&
            $store.state.csr.qrCodeList.length > 0
          "
        >
          <img :src="$store.state.csr.qrCodeList[0].qrCodePic" />
          <section>
            <h3>{{ $store.state.csr.qrCodeList[0].qrCodeTitle }}</h3>
            <p>{{ $store.state.csr.qrCodeList[0].qrCodeDes }}</p>
            <Button
              size="small"
              @click="$refs.erweima.open($store.state.csr.qrCodeList)"
              >{{
                $store.state.csr.qrCodeList.length == 1
                  ? "放大二维码"
                  : "更多二维码"
              }}</Button
            >
          </section>
        </ul>
      </div>
    </div>
    <div id="login_footer">
      <template
        v-if="$store.state.csr.company && $store.state.csr.company.length > 0"
      >
        {{ $store.state.csr.company }}
      </template>
      <a
        v-if="
          $store.state.csr.footerTitle &&
          $store.state.csr.footerTitle.length > 0
        "
        :href="$store.state.csr.footerLink"
        target="_blank"
        style="margin-left: 10px"
        >{{ $store.state.csr.footerTitle }}</a
      >
    </div>
    <moreAcount ref="moreAcount" @msg="reMsg"></moreAcount>
    <morePlat ref="morePlat"></morePlat>
    <erweima ref="erweima" v-if="$store.state.csr.qrCodeList&&$store.state.csr.qrCodeList.length>0"></erweima>
    <div id="hypt" @click="$refs.morePlat.reach()" v-if="!(hidehypt||hidehangye)">行业平台</div>
  </div>
</template>
<script>
var axios;
import moreAcount from "./moreAcount.vue";
import morePlat from "./morePlat.vue";
import erweima from "./erweima.vue";
export default {
  props:['hidehangye'],
  components: { moreAcount, morePlat, erweima },
  data() {
    return {
      loading: false,
      hidehypt: false,
      loginMsg: {
        username: "",
        password: "",
      },
      storagePasspord: false,
      logObj: {},
    };
  },
  methods: {
    reachData(a) {},
    reMsg(v) {
      if (v) {
        this.loginMsg = v;
        this.storagePasspord = true;
      } else {
        this.loginMsg.username = "";
        this.loginMsg.password = "";
        this.storagePasspord = false;
      }
    },
    login() {
      if (
        this.loginMsg.username.length == 0 ||
        this.loginMsg.password.length == 0
      ) {
        this.$Message.error("用户名或密码不能为空");
        return;
      }
      this.loading = true;
      let params = {
        account: this.loginMsg.username,
        password: this.loginMsg.password,
        platformId: this.axios.plat,
        tokenType: 2,
      };
      
      this.axios({
        method: "post",
        url: this.axios.commonAuth + "/auth/login/password",
        data: params,
      }).then((res) => {
        
        this.loading = false;
        var myData = res.data;
        if (myData.code == 200) {
          var obj = {
            accessToken: myData.data.accessToken,
            platformId: params.platformId,
            identityId: myData.data.identityId,
            customerId: myData.data.customerId,
            identityType: myData.data.identityType,
          };
          sessionStorage.setItem(this.axios.plat, JSON.stringify(obj));
          if (this.storagePasspord) {
            this.$refs.moreAcount.save(this.loginMsg);
          } else {
            this.$refs.moreAcount.del(this.loginMsg.username);
          }
          this.$emit("goto");
        } else {
          this.$Message.error(myData.message);
        }
      }).catch((err) => {
        this.loading = false;
        this.$Message.error(err.message);
      });
    },
    //回车键起来
    keyupEnter() {
      var that = this;
      document.onkeydown = function (event) {
        var e = event || window.event || arguments.callee.caller.arguments[0];
        if (e && e.keyCode == 13) {
          that.login();
        }
      };
    },

    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  },
  mounted() {
    this.keyupEnter();

    if (this.getUrlKey("t") == null) {
      this.hidehypt = false;
    } else {
      this.hidehypt = true;
    }
  },
  destroyed() {
    document.onkeydown = function (event) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        return;
      }
    };
  },
};
</script>
<style>
#nav {
  height: 80px;
  background: rgba(255, 255, 255, 1);
}
#nav h1 {
  font-size: 32px;
  font-weight: lighter;
  color: #333;
  float: left;
  line-height: 80px;
  margin-left: 10px;
}
#nav img {
  height: 40px;
  margin-right: 10px;
  margin-top: 20px;
  float: left;
}
#login_container {
  height: 560px;
  background: #ff2d2d;
}
#login_container .content {
  width: 1100px;
  margin: auto;
  position: relative;
}
#loginBtn {
  background: var(--loginColor);
  color: #fff;
  margin-top: 30px;
  margin-bottom: 10px;
}
#loginCheck .ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: var(--loginColor);
  background-color: var(--loginColor);
}
#bvad {
  float: left;
  color: #fff;
  position: absolute;
  top: 150px;
  opacity: 0.8;
}
#bvad h2 {
  font-size: 60px;
  font-weight: bold;
}
#bvad p {
  font-size: 30px;
}
#login-box {
  width: 360px;
  float: right;
  padding: 30px;
  background: rgb(255, 255, 255);
  margin-top: 50px;
  border-radius: 4px;
}
#login-box h2 {
  margin-bottom: 40px;
  font-size: 1.4em;
  text-align: center;
  margin-top: 20px;
}

#login_footer {
  line-height: 80px;
  text-align: center;
}
#erweima {
  position: absolute;
  bottom: -50px;
  display: flex;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 20px 10px 10px;
  border-radius: 10px;
}

#erweima h3 {
  font-size: 20px;
  margin-top: 0px;
  margin-bottom: 6px;
  color: #fff;
}
#erweima p {
  color: #fff;
  margin-bottom: 20px;
}
#erweima img {
  width: 90px;
  height: 90px;
  border: solid 4px #fff;
}
#erweima section {
  margin-left: 16px;
}
#hypt {
  position: fixed;
  left: 0;
  top: 200px;
  background: #f14835;
  writing-mode: tb-rl;
  line-height: 20px;
  border: solid 1px #fff;
  color: #fff;
  padding: 20px 4px;
  border-radius: 0 10px 10px 0;
  font-weight: bold;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/sys/login.vue